import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { differenceInMinutes, parseISO } from "date-fns";
import { Translate } from "react-admin";
import {
  HosDetailsDto,
  MobileApplicationType,
  VehicleIgnitionStatus,
} from "../../../common/data/service-proxies";
import { timespan } from "../../../common/util/timespan";

export interface MapBoundsChangedPayload {
  projection?: google.maps.Projection;
  zoom?: number;
  southWest?: google.maps.LatLng;
}

export interface MapBoundsChangedAction {
  type: string;
  payload: MapBoundsChangedPayload;
}

export interface InfoWindowProps {
  driverFullName?: string;
  dutyStatus?: string;
  drivingSpeed?: number | null;
  drivingSpeedUnit?: string | null;
  vehicleName?: string;
  eldConnected?: boolean | null;
  isPlugged?: boolean | null;
  geolocation?: string | null;
  isPluggedUpdateTime?: string | null;
  ignitionStatusUpdateTime?: string | null;
  fuelLevelUpdateTime?: string | null;
  fuelLevel?: string | null;
  trailers?: string | null;
  theme: Theme;
  translate: Translate;
  hosDetails?: HosDetailsDto | null;
  ignitionStatus?: VehicleIgnitionStatus | null;
  healthStatus?: boolean;
  safetyStatus?: boolean;
  mobileAppType?: MobileApplicationType | null;
  mobileAppVersion?: string | null;
  isMobile?: boolean | null;
}

export const getRemainingMinutes = (targetTime: string) => {
  const now = new Date();
  const targetDate = parseISO(targetTime);
  const delta = differenceInMinutes(targetDate, now);
  return delta < 0 ? 0 : delta;
};

export const getRemainingMinutesExtended = (
  targetTime: string | null | undefined,
  maxMinutes: number,
  minutesPassed: number
) => {
  if (targetTime) {
    return getRemainingMinutes(targetTime);
  }

  const delta = maxMinutes - minutesPassed;
  return delta < 0 ? 0 : delta;
};

export const getTime = (input: number) => {
  input *= 60 * 1000;
  const pattern = "h:m";
  return timespan.format(pattern, input);
};

export const useCircularStyles = makeStyles((theme: Theme) =>
  createStyles({
    circle: {
      strokeLinecap: "round",
    },
    bottom: {
      color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
  })
);

export const mapBoundsReducer = (
  previousState: MapBoundsChangedPayload,
  action: MapBoundsChangedAction
) => {
  if (action.type === "MAP_BOUNDS_CHANGED") {
    return { ...action.payload };
  }

  return previousState;
};
